import { SubmitAiFeedbackRequestSchema, SubmitAiFeedbackResponseSchema } from './submit-ai-feedback.schema';
/**
 * One payload, one service — but a route per agent, because the authorization
 * differs (`Read Bliksy` + recording access vs. the app-chat route's app/kind
 * entitlement) and policies are declared statically per handler. The path
 * carries which agent is meant, so the body does not have to.
 */ const feedbackStatusCodes = {
    success: 200,
    errors: {
        400: 'Bad Request - invalid feedback payload',
        401: 'Unauthorized - user not authenticated',
        403: 'Forbidden - caller may not read this conversation',
        404: 'Session not found, or the message is not an assistant message of it'
    }
};
/**
 * Submit Bliksy Feedback
 * Records a thumbs verdict on one Bliksy answer
 */ export const submitBliksyFeedbackContract = {
    method: 'POST',
    path: '/api/v2/bliksy/feedback',
    description: 'Submit, change or retract a thumbs verdict on an answer',
    requestSchema: SubmitAiFeedbackRequestSchema,
    responseSchema: SubmitAiFeedbackResponseSchema,
    statusCodes: feedbackStatusCodes
};

//# sourceMappingURL=submit-ai-feedback.contract.js.map